<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { LiveRadarPage } from '@/modules/live-radar';

const route = useRoute();

/**
 * Whether the active route is the per-frame debug graphs page
 * (`#/radar/debug/:id`, opened from MyEventsFeed's "📊 Графики отладки").
 * On that route we show RadarDebugPage; otherwise the live radar.
 */
const isDebugPage = computed(() => route.name === 'radar-debug');
</script>

<template>
  <!--
    LiveRadarPage stays MOUNTED at all times (v-show, not v-if): its
    useRadarLogic registers onUnmounted that disposes the detection pipeline,
    drops the socket, and stops monitoring. Unmounting it on navigation to the
    debug graphs would kill an active monitoring session — so we only hide it.
    RadarDebugPage is rendered on top via the router-view when its route is active.
  -->
  <LiveRadarPage v-show="!isDebugPage" />

  <router-view v-slot="{ Component }">
    <component
      :is="Component"
      v-if="isDebugPage"
    />
  </router-view>
</template>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  background: #0f1420;
}
</style>
